import WiredMono from "./WiredMono-Regular.otf"
import WiredMonoBold from "./WiredMono-Bold.otf"
import Apercu from "./Apercu-Regular-Pro.woff"
import ApercuBold from "./Apercu-Bold-Pro.woff"

const fonts = {
  "@font-face": [
    {
      fontFamily: "WiredMono",
      src: `url('${WiredMono}') format("woff")`,
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "WiredMono",
      src: `url('${WiredMonoBold}') format("woff")`,
      fontWeight: 700,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "Apercu",
      fontWeight: 700,
      fontStyle: "normal",
      fontDisplay: "swap",
      src: `url(${ApercuBold}) format("woff2"), url(${ApercuBold}) format("woff")`,
    },
    {
      fontFamily: "Apercu",
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
      src: `url(${Apercu}) format("woff2"), url(${Apercu}) format("woff")`,
    },
  ],
}

export default fonts
